export const reOrderData = (list: any[], startIndex: number, endIndex: number) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  for (let i = 0; i < result.length; i++) {
    result[i].queueNo = i + 1
  }
  return result
}

export function compareOrder(a: any, b: any) {
  if (a.queueNo < b.queueNo) {
    return -1
  }
  if (a.queueNo > b.queueNo) {
    return 1
  }
  return 0
}
export function compareStartDateOrder(a: any, b: any) {
  if (a.startDate < b.startDate) {
    return -1
  }
  if (a.startDate > b.startDate) {
    return 1
  }
  return 0
}


export function compareTitleOrder(a:any, b:any){
  let titleOne = a.title;
  let titleSecond = b.title;
  let alphabet = "AaBbCcÇçDdEeFfGgĞğHhIıİiJjKkLlMmNnOoÖöPpQqRrSsŞşTtUuÜüVvWwXxYyZz0123456789";
  if (titleOne.length === 0 || titleSecond.length === 0) {
    return titleOne.length - titleSecond.length;
  }
  for(let i=0;i<titleOne.length && i<titleSecond.length;i++){
    let ai = alphabet.indexOf(titleOne[i]);
    let bi = alphabet.indexOf(titleSecond[i]);
    if (ai !== bi) {
      return ai - bi;
    }
  }
  return 0;
}
export function compareNameOrder(a:any, b:any){
  let titleOne = a.name;
  let titleSecond = b.name;
  let alphabet = "AaBbCcÇçDdEeFfGgĞğHhIıİiJjKkLlMmNnOoÖöPpQqRrSsŞşTtUuÜüVvWwXxYyZz0123456789";
  if (titleOne.length === 0 || titleSecond.length === 0) {
    return titleOne.length - titleSecond.length;
  }
  for(let i=0;i<titleOne.length && i<titleSecond.length;i++){
    let ai = alphabet.indexOf(titleOne[i]);
    let bi = alphabet.indexOf(titleSecond[i]);
    if (ai !== bi) {
      return ai - bi;
    }
  }
  return 0;
}